import { render } from "./ModalNuevoTurno.vue?vue&type=template&id=a3ee728a"
import script from "./ModalNuevoTurno.vue?vue&type=script&lang=js"
export * from "./ModalNuevoTurno.vue?vue&type=script&lang=js"

import "./ModalNuevoTurno.vue?vue&type=style&index=0&id=a3ee728a&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__